import T from "../theme";
import { CATEGORIES } from "../data";
import Reveal from "../components/Reveal";
import { Section, SectionLabel } from "../components/Section";

export default function AboutSection() {
  return (
    <Section id="about" style={{ background: T.bg1 }}>
      <div className="section-pad" style={{ maxWidth: 1200, margin: "0 auto" }}>
        <Reveal><SectionLabel text="About" /></Reveal>
        <Reveal delay={0.05}>
          <h2 style={{ color: T.white, fontSize: "clamp(28px,4vw,52px)", fontWeight: 900, margin: "0 0 20px", letterSpacing: -1 }}>
            COM SCI Summit 2026
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p style={{ color: T.gray2, fontSize: "clamp(13px,1.5vw,15px)", lineHeight: 1.8, maxWidth: 680, marginBottom: 60 }}>
            The Computer Science Summit is the premier student-led technology exposition at Potisarnpittayakorn School.
            Now in its third year, it brings together 120+ participants across 8 disciplines to showcase projects at
            the frontier of digital innovation.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <h3 style={{ color: T.white, fontFamily: T.mono, fontSize: 12, letterSpacing: 3, marginBottom: 28, textTransform: "uppercase" }}>
            Competition Categories
          </h3>
        </Reveal>

        <div className="grid-categories">
          {CATEGORIES.map((c, i) => (
            <Reveal key={i} delay={i * 0.05} dir={i % 2 === 0 ? "up" : "right"}>
              <div style={{
                background: T.bgCard, border: `1px solid ${T.borderDim}`,
                borderRadius: 8, padding: "24px 20px", cursor: "default",
                borderTop: `2px solid ${T.blueDim}`, height: "100%",
              }}>
                <div style={{ fontSize: 22, marginBottom: 14, color: T.blue }}>{c.icon}</div>
                <div style={{ color: T.white, fontWeight: 700, fontSize: 14, marginBottom: 8 }}>{c.title}</div>
                <div style={{ color: T.gray2, fontSize: 12, lineHeight: 1.6 }}>{c.desc}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
